import { useNavigate } from 'react-router-dom';
import { useRantevouStore } from '../../../Stores/RantevouStore';
import { Stack, Tooltip, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { format } from 'date-fns';
import { useState } from 'react';
import { formatDateInDateMonthYear } from '../../../Common/formatDate/formatDate';
import { useEffect } from 'react';
import { useAuthStore } from '../../../Stores/AuthStore';
import { observer } from 'mobx-react-lite';
import { Visibility } from '@mui/icons-material';
import clsx from 'clsx';
import { palette } from '../../../styles/variables/colors';

const RantevouOverviewCurrentResults = () => {
  const { currentRantevouData, getCurrentRantevou, rantevouStatusesList } =
    useRantevouStore();
  const { authUser, isAdmin } = useAuthStore();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [currentDate] = useState(new Date());
  const [currentAppointments, setCurrentAppointments] = useState([]);

  useEffect(() => {
    setLoading(true);
    getCurrentRantevou(
      isAdmin ? '' : authUser?.subDepartmentId,
      format(currentDate, 'yyyy-MM-dd'),
      format(currentDate, 'yyyy-MM-dd')
    );
  }, []);

  useEffect(() => {
    if (currentRantevouData?.length > 0) {
      setCurrentAppointments(currentRantevouData);
    }
    setLoading(false);
  }, [currentRantevouData]);

  const viewRantevou = (id) => {
    navigate(`/rantevou/${id}`, {
      state: { returnToUrl: `/rantevou-overview` },
    });
  };

  const tableTitleClasses = clsx([
    'ml-4 my-2 pt-2',
    !currentAppointments?.length && 'pb-2',
  ]);

  const columns = [
    {
      field: 'id',
      headerName: 'Κωδ. ραντεβού',
      headerClassName: 'certificates-table-theme--header',
      cellClassName: 'certificates-table-theme--row',
      width: 200,
      align: 'center',
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <Typography
          align="center"
          variant="h5"
          component="div"
          className="flex items-center justify-center text-[14px] ml-1"
        >
          {params.row?.id ? params.row?.id : '-'}
        </Typography>
      ),
    },
    {
      field: 'subDepartment',
      headerName: 'Υποτμήμα',
      headerClassName: 'certificates-table-theme--header',
      cellClassName: 'certificates-table-theme--row',
      flex: 0.5,
      align: 'left',
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <Typography
          align="left"
          variant="h5"
          component="div"
          className="flex items-center text-[14px] ml-1"
        >
          {params.row?.subDepartment ? params.row?.subDepartment : '-'}
        </Typography>
      ),
    },
    {
      field: 'date',
      headerName: 'Ημερομηνία',
      headerClassName: 'certificates-table-theme--header',
      cellClassName: 'certificates-table-theme--row',
      flex: 0.5,
      align: 'left',
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <Typography
          align="left"
          variant="h5"
          component="div"
          className="flex items-center text-[14px] ml-1"
        >
          {params.row?.timeFrom
            ? format(new Date(params.row?.timeFrom), 'dd/MM/yyyy')
            : '-'}
        </Typography>
      ),
    },
    {
      field: 'timeFrom',
      headerName: 'Ώρα',
      headerClassName: 'certificates-table-theme--header',
      cellClassName: 'certificates-table-theme--row',
      flex: 0.5,
      align: 'left',
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <Typography
          align="left"
          variant="h5"
          component="div"
          className="flex items-center text-[14px] ml-1"
        >
          {params.row?.timeFrom ? params.row?.timeFrom?.slice(11, 16) : '-'} -{' '}
          {params.row?.timeTo ? params.row?.timeTo?.slice(11, 16) : '-'}
        </Typography>
      ),
    },
    {
      field: 'status',
      headerName: 'Κατάσταση',
      headerClassName: 'certificates-table-theme--header',
      cellClassName: 'certificates-table-theme--row',
      flex: 0.5,
      align: 'left',
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <Typography
          align="left"
          variant="h5"
          component="div"
          className="flex items-center text-[14px] ml-1"
        >
          {
            rantevouStatusesList.find((el) => el.value === params.row?.status)
              ?.description
          }
        </Typography>
      ),
    },
    {
      field: 'afm',
      headerName: 'ΑΦΜ Πολίτη',
      headerClassName: 'certificates-table-theme--header',
      cellClassName: 'certificates-table-theme--row',
      flex: 0.5,
      align: 'left',
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <Typography
          align="left"
          variant="h5"
          component="div"
          className="flex items-center text-[14px] ml-1"
        >
          {params.row?.afm ? params.row?.afm : '-'}
        </Typography>
      ),
    },
    {
      field: 'view',
      headerName: 'Προβολή',
      headerClassName: 'certificates-table-theme--header',
      cellClassName: 'certificates-table-theme--row',
      flex: 0.5,
      align: 'left',
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <Stack
          className="mr-36"
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Tooltip
            onClick={() => viewRantevou(params.row?.id)}
            placement="top"
            title={'Προβολή'}
          >
            <Visibility
              sx={{
                cursor: 'pointer',
                fontSize: '1.1rem',
                marginLeft: '1.8rem',
                color: '#333333B2',
              }}
            />
          </Tooltip>
        </Stack>
      ),
    },
  ];

  return (
    <>
      <div
        className="bg-[#003375] text-[#FFFFFF] text-[1.4rem]"
        style={{ width: '99%' }}
      >
        <div className={tableTitleClasses}>
          Τρέχοντα ραντεβού - {formatDateInDateMonthYear(currentDate)}{' '}
        </div>
        {!!currentAppointments?.length && (
          <DataGrid
            sx={{
              '& .certificates-table-theme--header': {
                backgroundColor: '#FFFFFF',
                borderBottom: '2px solid black',
              },
              '& .certificates-table-theme--row': {
                backgroundColor: '#FFFFFF',
                overflowWrap: 'break-word',
                minHeight: '40px !important',
                borderBottom: `1px solid ${palette.gray.light}`,
              },
              '& .MuiDataGrid-footerContainer': {
                backgroundColor: '#FFFFFF',
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 'bold',
                fontSize: '1rem',
              },
            }}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 },
              },
              // sorting: {
              //   sortModel: [
              //     { field: 'id', sort: 'desc' },
              //     { field: 'date', sort: 'desc' },
              //   ],
              // },
            }}
            rows={currentAppointments || []}
            getRowHeight={() => 'auto'}
            columns={columns}
            loading={!currentAppointments}
            pageSize={10}
            rowsPerPageOptions={[10]}
            autoHeight
            disableSelectionOnClick
            disableColumnSelector
            disableColumnMenu
          />
        )}
      </div>
      {!currentAppointments?.length && (
        <div className="flex justify-center items-center p-10">
          Δεν υπάρχουν αποτελέσματα
        </div>
      )}
    </>
  );
};

export default observer(RantevouOverviewCurrentResults);
